import actions from './actions';

export const apiActionStarted = payload => ({
  type: actions.API_ACTION_STARTED,
  payload
});
export const apiActionSucceeded = payload => ({
  type: actions.API_ACTION_SUCCEEDED,
  payload
});
export const apiActionFailed = payload => ({
  type: actions.API_ACTION_FAILED,
  payload
});
export const apiPatchData = payload => ({
  type: actions.API_PATCH_DATA,
  payload
});
export const apiClearData = key => ({type: actions.API_CLEAR_DATA, key});
export const setApiPath = value => ({
  type: actions.API_SET_PATH,
  payload: {value}
});
export const setSkillRecommendationApiPath = value => ({
  type: actions.API_SET_SKILL_RECOMMENDATION_API_PATH,
  payload: {value}
});
export const setWidgetId = value => ({
  type: actions.API_SET_WIDGETID,
  payload: {value}
});

export const apiGet = payload => apiActionStarted({...payload, method: 'get'});
export const apiPost = payload =>
  apiActionStarted({...payload, method: 'post'});
export const apiPut = payload => apiActionStarted({...payload, method: 'put'});
export const apiDelete = payload =>
  apiActionStarted({...payload, method: 'delete'});
export const apiPatch = payload =>
  apiActionStarted({...payload, method: 'patch'});

export const setApiCallLoading = payload => ({
  type: actions.API_SET_LOADING,
  payload
});
export const setNetworkIsDownFlag = () => ({type: actions.API_NETWORK_IS_DOWN});
